import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import ImageWrapper from '../../components/ImageWrapper';

const styles = css`
  padding: 64px 0;
  @media (min-width: 768px) {
    padding: 80px 40px;
  }
  @media (min-width: 992px) {
    padding: 72px 90px 100px;
  }
  @media (min-width: 1280px) {
    padding-left: 150px;
    padding-right: 150px;
  }
  .AreaContent_inner {
    @media (min-width: 992px) {
      max-width: 1170px;
      margin: 0 auto;
      &::after {
        content: '';
        display: table;
        clear: both;
      }
    }
  }
  .AreaContent_photoWrapper {
    width: 100%;
    height: calc((100vw - 40px) * 0.666667);
    img {
      max-width: 125%;
    }
    @media (min-width: 768px) {
      height: calc((100vw - 80px) * 0.666667);
    }
    @media (min-width: 992px) {
      width: 51.196581%;
      height: 27.847222vw;
      float: right;
      margin-left: 70px;
      margin-bottom: 40px;
    }
    @media (min-width: 1470px) {
      height: 401px;
      margin-left: 105px;
    }
  }
  .AreaContent_content {
    margin-top: 32px;
    @media (min-width: 768px) {
      margin-top: 36px;
    }
    @media (min-width: 992px) {
      width: 100%;
      margin-top: 0;
    }
  }
  .AreaContent_header {
    font-size: 32px;
    font-weight: 200;
    letter-spacing: 0.097273em;
    line-height: 1.181818;
    text-transform: uppercase;
    padding-bottom: 7.7px;
    margin-bottom: 11px;
    color: white;
    position: relative;
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 2px;
      background-color: #D6D6D6;
    }
    @media (min-width: 768px) {
      font-size: 44px;
      padding-bottom: 12px;
      margin-bottom: 15px;
      &::after {
        width: 75px;
        height: 3px;
      }
    }
    @media (min-width: 992px) {
      font-size: 52px;
      padding-bottom: 15px;
      margin-bottom: 19px;
    }
    @media (min-width: 1280px) {
      font-size: 55px;
    }
  }
  .AreaContent_headerSm {
    display: block;
    font-size: 0.527273em;
    font-weight: bold;
    letter-spacing: 0.027931em;
    line-height: 1.344828em;
    text-transform: none;
  }
  .AreaContent_copy {
    font-size: 13px;
    letter-spacing: 0.0375em;
    line-height: 1.875;
    color: white;
    @media (min-width: 768px) {
      font-size: 15px;
    }
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  .AreaContent_copy {
    > * {
      margin-bottom: 1em;
    }
    > :last-child {
      margin-bottom: 0;
    }
  }
`;


function AreaContent({ area, widget }) {
  const areaName = get(area, 'name', 'Broken Arrow');
  const areaCopy = get(area, 'description', get(widget, 'area_copy', ''));
  return (
    <div className={styles}>
      <div className="AreaContent_inner">
        <ImageWrapper
          className="AreaContent_photoWrapper"
          src={get(area, 'image.contentUrl') || get(widget, 'area_image.contentUrl')}
          alt="Area"
          width={800}
          height={800}
        />
        <div className="AreaContent_content">
          <h2 className="AreaContent_header">
            <span className="AreaContent_headerSm GoldText">Discover </span>{areaName}
          </h2>
          <div
            className="AreaContent_copy"
            dangerouslySetInnerHTML={SanitizeHtml(areaCopy)}
          />
        </div>
      </div>
    </div>
  );
}

AreaContent.propTypes = {
  area: PropTypes.object,
  widget: PropTypes.object.isRequired,
};

AreaContent.defaultProps = {
  area: undefined,
};

export default withData({
  widget: 'communities',
})(AreaContent);



// WEBPACK FOOTER //
// ./src/pages/Overview/AreaContent.js